import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logUsage } from 'owa-analytics';

export function logUsageBasedOnPremiumFlag(eventName, customData = null) {
    const customEventName = getUserConfiguration().SessionSettings?.IsPremiumConsumerMailbox
        ? eventName
        : `${eventName}NonPremium`;

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (12,31): Argument of type 'null' is not assignable to parameter of type 'CustomData | undefined'.
    // @ts-ignore
    logUsage(customEventName, customData, { isCore: true });
}
